import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.FavoriteVacancyCounter),
  () => import('./FavoriteVacanciesCounter'),
  (counter) => {
    ComponentUtil.binder(Hooks.FavoriteVacancyCounter, counter);
  },
);
